import {Stack} from "@mui/material";
const ContenedorHorizontal = ({children}) => {
    return(
        <Stack direction="row" spacing={2}>
                {children}
        </Stack>
    )
}
export default ContenedorHorizontal;